(() => {
  function mount(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = (s) => root.querySelector(s);
    const data = JSON.parse($('[data-aura-data]').textContent);
    const form = $('[data-aura-form]');
    const single = $('[data-single]');
    const both = $('[data-both]');
    const braSelect = $('[data-bra-size]');
    const braError = $('[data-bra-error]');
    const matchError = $('[data-match-error]');
    const matchStatus = $('[data-match-status]');
    const sizeError = $('[data-size-error]');
    const sizeGroup = $('.cp-aura__sizes');
    const error = $('[data-error]');
    const status = $('[data-status]');
    let busy = false;
    let uncertain = false;
    let cartState = data.cartState || {leggings:false, bra:false};
    let appliedSaving = data.offerAppliedSaving || 0;
    let syncVersion = 0;
    let disposed = false;
    const cartEndpoint = root.dataset.cartUrl.replace(/\/$/, '') + '.js';
    const braSelected = () => data.braVariants?.find(v => v.id === braSelect?.value);
    const money = cents => new Intl.NumberFormat(data.locale || 'en-GB', {style:'currency',currency:data.currency || 'GBP'}).format(cents / 100);
    const readCart = async () => {
      const response = await fetch(cartEndpoint, {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Could not check the bag.');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Could not check the bag.');
      return cart;
    };
    function applyCart(cart) {
      const code = (data.offerCode || '').toLowerCase();
      appliedSaving = code ? cart.items.reduce((sum, item) => sum + (item.line_level_discount_allocations || item.discount_allocations || []).reduce((total, allocation) => {
        return (allocation.discount_application?.title || '').toLowerCase() === code ? total + (Number(allocation.amount) || 0) : total;
      }, 0), 0) : 0;
      cartState = {
        leggings: cart.items.some(item => String(item.product_id || item.product?.id) === data.productId),
        bra: cart.items.some(item => String(item.product_id || item.product?.id) === data.braProductId)
      };
      if (both && (cartState.leggings || cartState.bra)) $('[data-addon-controls]').open = true;
      updateMatch();
    }
    async function syncCart() {
      if (!both || busy || disposed) return;
      const version = ++syncVersion;
      try {
        const cart = await readCart();
        if (!disposed && !busy && version === syncVersion) applyCart(cart);
      } catch (_) { /* Every add action checks again; never mutate from this cached state. */ }
    }
    function updateMatch() {
      if (!both) return;
      const leg = selected() || data.variants.find(v => v.available) || data.variants[0];
      const bra = braSelected() || data.braVariants.find(v => v.available) || data.braVariants[0];
      const hasLeg = cartState.leggings, hasBra = cartState.bra;
      const state = hasLeg && hasBra ? 'complete' : hasLeg ? 'bra' : hasBra ? 'leggings' : 'pair';
      const copy = {
        complete: ['View your bag', 'Your set is in the bag', 'Your leggings and matching bra are already in your bag.', 'Your matching set is ready. Review your bag to continue.'],
        bra: ['Add matching bra', 'Add the matching bra', 'Leggings added to your bag. Complete your set with the matching bra.', 'Choose your bra size to complete the look.'],
        leggings: ['Add leggings to bag', 'Add the leggings', 'Matching bra added to your bag. Complete your set with the leggings.', 'Choose your leggings size to complete the look.'],
        pair: ['Add both pieces to bag', 'Complete your set', 'Choose your leggings size above and your bra size below.', 'Create your matching set with a separate size for each piece.']
      }[state];
      const available = (hasLeg || data.variants.some(v=>v.available)) && (hasBra || data.braVariants.some(v=>v.available));
      if (!busy) both.textContent = uncertain ? 'Check your bag' : !available ? 'Matching piece sold out' : copy[0];
      both.disabled = busy || (!uncertain && !available);
      $('[data-match-summary]').textContent = copy[1];
      $('[data-match-hint]').textContent = copy[2];
      $('[data-match-note]').textContent = copy[3];
      $('[data-bra-picker]').hidden = hasBra;
      if (hasBra && braError) {braError.hidden = true;braSelect.removeAttribute('aria-invalid');}
      $('[data-match-total]').hidden = state === 'complete';
      const legPrice = leg?.price || 0;
      const braPrice = bra?.price || 0;
      const regularTotal = (hasLeg ? 0 : legPrice) + (hasBra ? 0 : braPrice);
      const setSaving = state === 'pair' && data.offerCode && appliedSaving === 0 ? Math.min(data.offerAmount, regularTotal) : 0;
      $('[data-total-label]').textContent = hasLeg ? 'Matching bra' : hasBra ? 'Leggings' : 'Set price';
      $('[data-total]').textContent = money(regularTotal - setSaving);
      $('[data-set-regular]').hidden = !setSaving;
      $('[data-set-regular]').textContent = money(regularTotal);
      $('[data-set-saving]').hidden = !setSaving;
      $('[data-set-saving]').textContent = `You save ${money(setSaving)}`;
      if (bra) $('[data-bra-price]').textContent = bra.priceText;
      const offer = $('[data-product-offer]');
      if (offer) {
        offer.hidden = state === 'complete';
        offer.textContent = appliedSaving > 0 ? 'Your pairing offer is already applied to this order.' : setSaving ? `Complete your set for ${money(regularTotal - setSaving)}. Save ${money(setSaving)}.` : `Save ${money(data.offerAmount)} when you choose 2 or more eligible Aura pieces. Once per order.`;
        if ($('[data-product-offer-terms]')) $('[data-product-offer-terms]').hidden = state === 'complete';
      }
    }
    function revealSize(target, control) {
      // Finish button/layout updates before moving focus. Focus first so Safari
      // cannot cancel an in-flight smooth scroll when it focuses the input.
      requestAnimationFrame(() => {
        if (disposed) return;
        control?.focus({preventScroll:true});
        target.scrollIntoView({behavior:'instant', block:'center'});
      });
    }
    function leggingsRequired() {
      sizeError.textContent = data.sizePrompt || 'Choose your leggings size to add to bag.';
      sizeError.hidden = false;sizeGroup.setAttribute('aria-invalid', 'true');
      form.querySelectorAll('[name="id"]:not(:disabled)').forEach(input => input.setAttribute('aria-invalid', 'true'));
      revealSize(sizeGroup, form.querySelector('[name="id"]:not(:disabled)'));
    }
    async function applyMatchingDiscount() {
      if (!data.offerCode) return;
      let notice = '';
      try {
        const cart = await readCart();
        const codes = (cart.discount_codes || []).map(item=>item.code);
        [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(item=>(item.line_level_discount_allocations || []).map(a=>a.discount_application))].forEach(item=>{if(item?.type === 'discount_code') codes.push(item.title);});
        if (!codes.some(code=>code?.toLowerCase() === data.offerCode.toLowerCase())) codes.push(data.offerCode);
        const response = await fetch(root.dataset.cartUrl.replace(/\/$/, '') + '/update.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:[...new Set(codes.filter(Boolean))].join(',')})});
        const result = await response.json();
        if (!response.ok || !result.discount_codes?.some(item=>item.code.toLowerCase() === data.offerCode.toLowerCase() && item.applicable === true)) notice = 'Your pieces were added, but the matching offer did not apply to this bag. Check the total before checkout.';
      } catch (_) {notice = 'Your pieces were added. We could not confirm the matching discount; check your total before checkout.';}
      try {
        if (notice) sessionStorage.setItem('cp-match-notice-v19',JSON.stringify({message:notice,time:Date.now()}));
        else sessionStorage.removeItem('cp-match-notice-v19');
      } catch (_) {}
    }
    const selected = () => data.variants.find(v => v.id === form.querySelector('[name="id"]:checked')?.value) || (data.defaultVariant ? data.variants.find(v => v.available) : null);
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    function update() {
      const v = selected();
      if (v) {
        $('[data-price]').textContent = v.priceText;
        $('[data-sticky-price]').textContent = v.priceText;
        $('[data-compare]').textContent = v.compareText;
        $('[data-compare]').hidden = !(v.compare > v.price);
        $('[data-sticky-label]').textContent = data.defaultVariant ? 'Add to bag' : `Add ${v.title} to bag`;
        if ($('[data-single-label]')) $('[data-single-label]').textContent = data.defaultVariant ? 'Add to bag' : `Add ${v.title} to bag`;
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      if (v?.available) {
        sizeError.hidden = true;
        sizeError.textContent = '';
        sizeGroup.removeAttribute('aria-invalid');
        form.querySelectorAll('[name="id"]').forEach(input => input.removeAttribute('aria-invalid'));
      }
      updateMatch();
    }
    function showError(message, cartLink = false) {
      error.textContent = message;
      if (cartLink) {
        const link = document.createElement('a');
        link.href = root.dataset.cartUrl;
        link.textContent = ' Check your bag';
        error.append(link);
      }
      error.hidden = false;
      error.focus();
    }
    async function add(mode = 'leggings') {
      if (busy) return;
      const matching = mode === 'match';
      if (uncertain) {if (matching) location.assign(root.dataset.cartUrl);return;}
      error.hidden = true;
      if (matchError) matchError.hidden = true;
      if (!matching && !selected()?.available) {leggingsRequired();return;}
      busy = true;
      ++syncVersion;
      single.disabled = true;
      $('[data-choose]').disabled = true;
      if (both) both.disabled = true;
      const progress = matching ? matchStatus : status;
      progress.textContent = matching ? 'Checking your bag…' : 'Adding to your bag…';
      if (matching) both.textContent = 'Checking your bag…';
      form.setAttribute('aria-busy', 'true');
      let posted = false;
      let missingSize = '';
      try {
        const items = [];
        let addingBra = false;
        if (matching) {
          // Fresh cart state decides which pieces are missing, regardless of the visible button label.
          const cart = await readCart();
          applyCart(cart);
          if (cartState.leggings && cartState.bra) {location.assign(root.dataset.cartUrl);return;}
          const leg = selected(), bra = braSelected();
          if (!cartState.leggings && !leg?.available) {missingSize = 'leggings';progress.textContent = '';return;}
          if (!cartState.bra && !bra?.available) {
            missingSize = 'bra';
            progress.textContent = '';return;
          }
          if (!cartState.leggings) items.push({id:leg.id,quantity:1});
          if (!cartState.bra) {items.push({id:bra.id,quantity:1});addingBra = true;}
          progress.textContent = items.length === 2 ? 'Adding your set…' : addingBra ? 'Adding the matching bra…' : 'Adding your leggings…';
          both.textContent = 'Adding…';
        } else items.push({id:selected().id,quantity:1});
        posted = true;
        const response = await fetch(root.dataset.cartAdd, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify({items})});
        const body = await response.json();
        if (!response.ok) {
          uncertain = true;
          const message = (typeof body.description === 'string' ? body.description : 'An item could not be added. Availability may have changed.') + ' Check your bag before trying again.';
          if (matching) {matchError.textContent = message;matchError.hidden = false;matchError.focus();}
          else showError(message, true);
          return;
        }
        // Keep a confirmed local state for browser Back; refresh again on pageshow.
        if (matching) cartState = {leggings:true,bra:true}; else cartState = {...cartState,leggings:true};
        if (matching && data.offerCode) await applyMatchingDiscount();
        progress.textContent = 'Added. Opening your bag…';
        const feedbackSource = root.contains(document.activeElement) && document.activeElement.tagName === 'BUTTON' ? document.activeElement : single;
        await window.CPShopping?.added(feedbackSource, root.querySelector('[data-gallery] img'));
        location.assign(root.dataset.cartUrl);
      } catch (_) {
        if (posted) uncertain = true;
        const message = posted ? 'We could not confirm the update. Please check your bag before adding again.' : 'We could not check your bag. Please try again.';
        if (matching) {matchError.textContent = message;matchError.hidden = false;matchError.focus();}
        else showError(message, posted);
        progress.textContent = '';
      } finally {
        busy = false;
        form.removeAttribute('aria-busy');
        if (!uncertain) {
          single.disabled = !data.variants.some(x=>x.available);
          $('[data-choose]').disabled = single.disabled;
        } else {progress.textContent = ''; $('[data-sticky-label]').textContent = 'Check your bag'; $('[data-choose]').disabled = false;}
        updateMatch();
        if (missingSize === 'leggings') leggingsRequired();
        if (missingSize === 'bra') {
          $('[data-addon-controls]').open = true;
          braError.textContent = 'Choose your bra size to complete your set.';
          braError.hidden = false;
          braSelect.setAttribute('aria-invalid','true');
          revealSize($('[data-bra-picker]'), braSelect);
        }
      }
    }
    if (both) {
      $('[data-addon-controls]').hidden = false;
      both.addEventListener('click', () => add('match'));
      braSelect.addEventListener('change', () => {
        braError.hidden = true;braError.textContent = '';braSelect.removeAttribute('aria-invalid');
        if (matchError) matchError.hidden = true;
        updateMatch();
      });
      window.addEventListener('pageshow', syncCart);
      document.addEventListener('cart:update', syncCart);
      document.addEventListener('cart:refresh', syncCart);
      const visible = () => {if (!document.hidden) syncCart();};
      document.addEventListener('visibilitychange', visible);
      root._matchCleanup = () => {
        disposed = true;++syncVersion;
        window.removeEventListener('pageshow',syncCart);
        document.removeEventListener('cart:update',syncCart);
        document.removeEventListener('cart:refresh',syncCart);
        document.removeEventListener('visibilitychange',visible);
      };
      syncCart();
    }
    form.addEventListener('submit', e => {e.preventDefault(); add();});
    form.addEventListener('change', update);
    // Preserve attribution and unpublished-theme preview when switching colours.
    root.querySelectorAll('[data-colour-link]').forEach(link => {
      const target = new URL(link.href);
      new URL(location.href).searchParams.forEach((value, key) => {
        if (/^utm_/.test(key) || ['fbclid','gclid','gbraid','wbraid','campaign_id','adset_id','adgroup_id','ad_id','site_source_name','placement','preview_theme_id'].includes(key)) target.searchParams.set(key,value);
      });
      link.href = target.href;
    });
    const gallery = $('[data-gallery]');
    const slides = [...gallery.children];
    $('[data-gallery-controls]').hidden = slides.length < 2;
    const thumbs = $('[data-thumbnails]');
    const thumbButtons = [];
    if (thumbs) {
      slides.forEach((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `Show product ${slide.querySelector('video') ? 'video' : 'photo'} ${index + 1}`);
        const source = slide.querySelector('img');
        if (source) {
          const img = document.createElement('img');
          img.src = slide.dataset.thumbnail || source.currentSrc || source.src;
          img.alt = ''; img.loading = 'lazy';
          button.append(img);
        } else {
          const poster = slide.querySelector('video')?.poster;
          if (poster) {const img=document.createElement('img');img.src=poster;img.alt='';img.loading='lazy';button.append(img);}
          else button.textContent = 'Video';
        }
        if (slide.querySelector('video')) { const badge=document.createElement('span');badge.className='cp-aura__thumb-play';badge.textContent='Video';badge.setAttribute('aria-hidden','true');button.append(badge); }
        button.addEventListener('click', () => gallery.scrollTo({left:index * gallery.clientWidth, behavior:motion()}));
        thumbs.append(button); thumbButtons.push(button);
      });
      thumbs.hidden = slides.length < 2;
    }

    let frame;
    let activeIndex = 0;
    const zoomButton = $('[data-zoom]');
    const lightbox = $('[data-lightbox]');
    const lightboxImage = $('[data-lightbox-image]');
    const lightboxPhoto = $('[data-lightbox-photo]');
    const photoSlides = slides.filter(slide => slide.querySelector('img') && !slide.querySelector('video'));
    let photoIndex = 0;
    function showPhoto(index) {
      photoIndex = Math.max(0, Math.min(photoSlides.length - 1, index));
      const original = photoSlides[photoIndex].querySelector('img');
      lightboxImage.src = original.src;
      lightboxImage.alt = original.alt || data.title || 'Product photo';
      $('[data-lightbox-count]').textContent = `Photo ${photoIndex + 1} of ${photoSlides.length}`;
      $('[data-lightbox-prev]').disabled = photoIndex === 0;
      $('[data-lightbox-next]').disabled = photoIndex === photoSlides.length - 1;
      setPhotoZoom(true);
    }
    function centrePhoto() {
      if (!lightbox.open || !lightboxPhoto.classList.contains('is-zoomed')) return;
      lightboxPhoto.scrollTo({
        left: Math.max(0, (lightboxPhoto.scrollWidth - lightboxPhoto.clientWidth) / 2),
        top: Math.max(0, (lightboxPhoto.scrollHeight - lightboxPhoto.clientHeight) / 2),
        behavior: 'instant'
      });
    }
    function setPhotoZoom(zoomed) {
      lightboxPhoto.classList.toggle('is-zoomed', zoomed);
      $('[data-lightbox-zoom]').setAttribute('aria-pressed', String(zoomed));
      $('[data-lightbox-zoom]').textContent = zoomed ? 'Fit photo' : 'Zoom in';
      if (zoomed) requestAnimationFrame(centrePhoto);
      else lightboxPhoto.scrollTo({left: 0, top: 0, behavior: 'instant'});
    }
    lightboxImage?.addEventListener('load', centrePhoto);
    zoomButton?.addEventListener('click', () => {
      const index = photoSlides.indexOf(slides[activeIndex]);
      if (index < 0 || !lightbox?.showModal) return;
      showPhoto(index);
      lightbox.showModal();
      requestAnimationFrame(centrePhoto);
      $('[data-lightbox-close]').focus({preventScroll: true});
    });
    $('[data-lightbox-close]')?.addEventListener('click', () => lightbox.close());
    lightbox?.addEventListener('close', () => zoomButton.focus({preventScroll:true}));
    lightbox?.addEventListener('click', e => { if (e.target === lightbox) lightbox.close(); });
    $('[data-lightbox-prev]')?.addEventListener('click', () => showPhoto(photoIndex - 1));
    $('[data-lightbox-next]')?.addEventListener('click', () => showPhoto(photoIndex + 1));
    $('[data-lightbox-zoom]')?.addEventListener('click', () => {
      setPhotoZoom(!lightboxPhoto.classList.contains('is-zoomed'));
    });
    lightbox?.addEventListener('keydown', e => {
      if (lightboxPhoto.classList.contains('is-zoomed')) return;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();showPhoto(photoIndex + (e.key === 'ArrowLeft' ? -1 : 1));
      }
    });
    const refresh = () => {
      const index = Math.max(0, Math.min(slides.length - 1, Math.round(gallery.scrollLeft / (gallery.clientWidth || 1))));
      activeIndex = index;
      const ratio = 0.8;
      const height = `${Math.round(gallery.clientWidth / ratio)}px`;
      if (gallery.clientWidth && gallery.style.getPropertyValue('--aura-gallery-height') !== height) {
        gallery.style.setProperty('--aura-gallery-height', height);
      }

      if (zoomButton) zoomButton.hidden = !lightbox?.showModal || !slides[index]?.querySelector('img') || !!slides[index]?.querySelector('video');
      slides.forEach((slide, i) => {if (i !== index) slide.querySelector('video')?.pause();});
      $('[data-gallery-count]').textContent = `${index + 1} / ${slides.length}`;
      thumbButtons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      $('[data-prev]').disabled = index === 0;
      $('[data-next]').disabled = index >= slides.length - 1;
    };
    gallery.addEventListener('scroll', () => {cancelAnimationFrame(frame);frame=requestAnimationFrame(refresh);}, {passive:true});
    gallery.addEventListener('keydown', e => {
      // Leave video-player controls and other focused children to the browser.
      if (e.target !== gallery || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
      e.preventDefault();
      if (e.key === 'Home' || e.key === 'End') {
        gallery.scrollTo({left:e.key === 'Home' ? 0 : (slides.length - 1) * gallery.clientWidth, behavior:motion()});
      } else gallery.scrollBy({left:(e.key === 'ArrowLeft' ? -1 : 1) * gallery.clientWidth, behavior:motion()});
    });
    $('[data-prev]').addEventListener('click', () => gallery.scrollBy({left:-gallery.clientWidth,behavior:motion()}));
    $('[data-next]').addEventListener('click', () => gallery.scrollBy({left:gallery.clientWidth,behavior:motion()}));
    refresh();
    function chooseSize() {
      if (data.defaultVariant) { revealSize(single, single); return; }
      revealSize(sizeGroup, form.querySelector('[name="id"]:not(:disabled)'));
    }
    $('[data-choose]').addEventListener('click', () => {
      if (uncertain) {location.assign(root.dataset.cartUrl);return;}
      if (selected()?.available) add(); else chooseSize();
    });
    $('[data-back-to-size]')?.addEventListener('click', chooseSize);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const available=data.variants.some(v=>v.available);
        // The bar belongs to the part of the journey after the buying controls.
        // An offscreen button below the opening gallery must not trigger it.
        const passedButton = entry.boundingClientRect.bottom <= (entry.rootBounds?.top || 0);
        $('[data-sticky]').hidden = entry.isIntersecting || !passedButton || !available;
      }, {threshold:0});
      observer.observe(single);
      root._auraCleanup = () => observer.disconnect();
    }
    let galleryWidth = gallery.clientWidth;
    const resize = new ResizeObserver(() => {
      if (galleryWidth !== gallery.clientWidth) {
        galleryWidth = gallery.clientWidth;
        gallery.scrollTo({left:activeIndex * galleryWidth,behavior:'instant'});
      }
      refresh();
    });
    resize.observe(gallery);
    gallery.querySelectorAll('[data-film-controls]').forEach(controls => resize.observe(controls));
    // Keep one video playing, and pause it when offscreen or the tab is hidden.
    const videos = [...root.querySelectorAll('video')].filter(video => !video.closest('cp-film-player'));
    videos.forEach(video => video.addEventListener('play', () => videos.forEach(other => {if(other !== video) other.pause();})));
    const videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {if(!entry.isIntersecting) entry.target.pause();}), {threshold:0}) : null;
    videos.forEach(video => videoObserver?.observe(video));
    const onVisibility = () => {if(document.hidden) videos.forEach(video => video.pause());};
    document.addEventListener('visibilitychange', onVisibility);
    const oldCleanup=root._auraCleanup;
    root._auraCleanup=()=>{root._matchCleanup?.();oldCleanup?.();resize.disconnect();videoObserver?.disconnect();document.removeEventListener('visibilitychange',onVisibility);videos.forEach(video=>video.pause());if(lightbox?.open) lightbox.close();cancelAnimationFrame(frame);};
    root.querySelectorAll('details').forEach(detail=>detail.addEventListener('toggle',()=>{
      if (!detail.open) detail.querySelectorAll('video').forEach(video=>video.pause());
    }));
    update();
    // Enable inline validation only after the enhanced form has mounted.
    // Without JavaScript, the required radios retain native form validation.
    form.noValidate = true;
  }
  document.querySelectorAll('[data-aura]').forEach(mount);
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-aura]').forEach(root=>root._auraCleanup?.()));
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-aura]').forEach(mount));
})();
